package it.neckar.lizergy.model.company

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@SerialName("plannerCompanyInformation")
@Serializable
data class PlannerCompanyInformation(
  override val companyProfile: CompanyProfile,
  override val name: String,
  override val address: it.neckar.lizergy.model.customer.Address,
  override val contactInformation: ContactInformation,
  override val bankInformation: PvBankInformation,
  override val legalInformation: CompanyLegalInformation,

  /**
   * The default user for this company. Will be used as assignee for new tasks/projects.
   * If no default user is configured the first user will be assigned
   */
  val defaultUser: UserLoginName,

  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : CompanyInformation {

  val companyCode: CompanyCode
    get() = companyProfile.companyCode

  companion object {

    val NeckarIT: PlannerCompanyInformation = PlannerCompanyInformation(
      companyProfile = NeckarITCompanyProfile,
      name = "Neckar IT GmbH",
      address = it.neckar.lizergy.model.customer.AddressExample.neckarIT,
      contactInformation = ContactInformation.NeckarIT,
      bankInformation = PvBankInformation.NeckarIT,
      legalInformation = CompanyLegalInformation.NeckarIT,
      defaultUser = UserLoginName.NeckarIT,
    )

    val NeckarITCompanyTree: ResolvedCompanyTree = ResolvedCompanyTree(
      company = NeckarIT,
      parentCompany = null,
      childCompanies = null,
    )

    /**
     * Returns a company information with default values
     */
    fun createStubCompany(companyCode: CompanyCode): PlannerCompanyInformation {
      return PlannerCompanyInformation(
        companyProfile = TestCompanyProfile(companyCode),
        name = companyCode.value.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
        address = it.neckar.lizergy.model.customer.Address.empty,
        contactInformation = ContactInformation.empty,
        bankInformation = PvBankInformation.empty,
        legalInformation = CompanyLegalInformation.empty,
        defaultUser = UserLoginName(companyCode.value),
      )
    }

    /**
     * Returns a company information with default non-empty values
     */
    fun createDemoCompany(companyCode: CompanyCode): PlannerCompanyInformation {
      return PlannerCompanyInformation(
        companyProfile = TestCompanyProfile(companyCode),
        name = companyCode.value.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
        address = it.neckar.lizergy.model.customer.AddressExample.muster,
        contactInformation = ContactInformation.demo,
        bankInformation = PvBankInformation.demo,
        legalInformation = CompanyLegalInformation.demo,
        defaultUser = UserLoginName(companyCode.value),
      )
    }

  }
}
